module.exports = __webpack_public_path__ + "img/isPro1_1.5c2efe51.png";